import { render, staticRenderFns } from "./RemoveTeamMember.vue?vue&type=template&id=accfc93c&scoped=true&"
import script from "./RemoveTeamMember.vue?vue&type=script&lang=js&"
export * from "./RemoveTeamMember.vue?vue&type=script&lang=js&"
import style0 from "./RemoveTeamMember.vue?vue&type=style&index=0&id=accfc93c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accfc93c",
  null
  
)

export default component.exports